import { BackIcon, BackToTopIcon, PDFIcon, DropdownIcon, FilterIcon, CheckmarkIcon, PlayIcon, AddToProjectIcon, FavoriteIcon, EditIcon, ShareIcon, PrintIcon, EmailIcon, DownloadIcon, ExternalLinkIcon, InternalLinkIcon } from '@kohler-dsm-library/kohler-icons';

const actionIndicatorIconPath = {
  "Copy link": { leftIcon: InternalLinkIcon },
  "External link": { leftIcon: ExternalLinkIcon },
  Download: { leftIcon: DownloadIcon },
  Email: { leftIcon: EmailIcon },
  Print: { leftIcon: PrintIcon },
  Share: { leftIcon: ShareIcon },
  Manage: { leftIcon: EditIcon },
  Favorites: { leftIcon: FavoriteIcon },
  Projects: { leftIcon: AddToProjectIcon },
  "Video link": { leftIcon: PlayIcon },
  Compare: { leftIcon: CheckmarkIcon },
  Filters: { rightIcon: FilterIcon },
  Sort: { rightIcon: DropdownIcon },
  "PDF link": { leftIcon: PDFIcon },
  "PDF file": { leftIcon: PDFIcon },
  "Back to top": { rightIcon: BackToTopIcon },
  Back: { leftIcon: BackIcon }
};

export { actionIndicatorIconPath };
